<!-- PointCloudView.vue -->
<script lang="ts">
import {defineComponent, computed, onMounted, type ComputedRef, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import MapComponent from '@/components/MapComponent.vue'
import { useMapStore } from '@/stores/mapStore'
import VectorSource from 'ol/source/Vector.js'
import FileListVue from '@/components/FileList.vue'
import WebGLPointsLayer from 'ol/layer/WebGLPoints'
import GeoJSON from 'ol/format/GeoJSON'
import { Style, Circle as CircleStyle, Fill } from 'ol/style'
import Overlay from 'ol/Overlay'
import Chart from 'chart.js/auto'
// vue date range

export default defineComponent({
  components: {
    MapComponent,
    FileListVue
  },

  setup() {
    const route = useRoute()
    const siteId = computed(() => route.params.site_id) as ComputedRef<string>
    const mapStore = useMapStore()

    console.log(siteId.value)
    var geoJsonUrl = '';
    if (siteId.value === 'Hinkley') {
      geoJsonUrl = '/api/media/protected_image/stew123/Hinkley/Sentinel1_stack_1.geojson' // Replace with your GeoJSON file URL
    } else {
      geoJsonUrl = '/api/media/protected_image/stew123/Bradwell/Sentinel1_stack_1.geojson' // Replace with your GeoJSON file URL
    }


    // Coh threshold value for slider
    const slider = document.getElementById('coherence-threshold')
    const cohThreshold = ref(0.7)

    const baseWidth = ref(720)
    const updatePopupWidth = (mapWidth: number) => {
      // Set the width of the popup as a proportion of the map width
      baseWidth.value = mapWidth * 0.5
    }
    const featuresContainer = ref([])
    const globalGeoJsonFormat = new GeoJSON()

    onMounted(() => {
      const map = mapStore.map
      if (!map) {
        throw new Error('Map not initialized')
      }


      fetch(geoJsonUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
          }
          return response.json()
        })
        .then(data => {
          if (!data || typeof data !== 'object') {
            throw new Error('Invalid GeoJSON data')
          }

          // Store the features in the container
          featuresContainer.value = data;


          // data.features = data.features.filter((feature) => {
          //     return feature.properties.COHERENCE > 0.7
          // })

          const geoJsonFormat = new GeoJSON()
          const features = geoJsonFormat.readFeatures(data, {
            // source projection is EPSG:4326
            dataProjection: 'EPSG:4326',
            featureProjection: map.getView().getProjection()
          })



          // Filter out features with no geometry
          features.forEach((feature) => {
            if (!feature.getGeometry()) {
              console.warn('Feature has no geometry:', feature)
            }
          })

          const vectorSource = new VectorSource({
            features: features,
            format: geoJsonFormat,
            wrapX: false
          })

          console.log(features[1])


          const webGLPointsLayer = new WebGLPointsLayer({
            source: vectorSource,
            // style: new Style({
            //     image: new CircleStyle({
            //         radius: 5,
            //         fill: new Fill({ color: '#ff0000' })
            //     })
            // })
            style: {
              'circle-radius': 3,
              'circle-fill-color': [
                'interpolate',
                ['linear'],
                ['get', 'VEL'],
                -0.01, '#ff0000',
                -0.005, '#aaaa00',
                0, '#00ff00',
                0.005, '#00aaaa',
                0.01, '#0000ff'
              ],
              // 'circle-fill-color': [
              //     'interpolate',
              //     ['linear'],
              //     ['get', 'COHERENCE'],
              //     0.0, '#000000',
              //     1.0, '#ffffff'
              // ],
              // 'circle-fill-color': '#ff0000',
              'circle-rotate-with-view': false,
              'circle-displacement': [0, 0],

            }
          })

          map.addLayer(webGLPointsLayer)

          const extent = webGLPointsLayer.getSource().getExtent();
          map.getView().fit(extent, { size: map.getSize(), maxZoom: 18 });
          console.log(features)

          // // remove any feature with coherence less than 0.01
          // vectorSource.getFeatures().forEach((feature) => {
          //     if (feature.get('COH') < 0.7) {
          //         vectorSource.removeFeature(feature);
          //     }
          // })

        })
        .catch(error => {
          console.error('Error loading GeoJSON:', error)
        })


      const pop_container = document.getElementById('popup')
      const pop_content = document.getElementById('popup-content')
      const pop_closer = document.getElementById('popup-closer')

      // Make sure these are not null
      if (pop_container === null || pop_content === null || pop_closer === null) {
        throw new Error('popup elements are null')
      }

      const pop_overlay = new Overlay({
        element: pop_container,
        autoPan: {
          animation: {
            duration: 500
          }
        },
        positioning: 'bottom-left'
      })
      pop_closer.onclick = function () {
        pop_overlay.setPosition(undefined)
        pop_closer.blur()
        return false
      }

      // Add an onclick-event to the map
      map.on('click', (event) => {
        // Get the coordinates of the pointer event
        const coords = event.coordinate
        const coordsFormat1 = coords.map((coord) => coord.toFixed(0)).join(', ')

        // coordinates style - seperate little grey box
        const coordsStyle = "background-color: rgba(200, 200, 200, 0.5); padding: 5px; border-radius: 5px;"
        // const addStyle => (message: string) => {
        //   return `<span style="${coordsStyle}">${message}</span>`
        // }
        // Add the coordinates to the popup content
        // pop_content.innerHTML = `<p>Coordinates: ${coordsFormat2}</p>`
        // With style:
        if (siteId.value === 'Hinkley') {
          pop_content.innerHTML = `<h3>Time Series - Sentinel-1 Track 30 LOS</h3>`
        } else {
          pop_content.innerHTML = `<h3>Time Series - Sentinel-1 Track 81 LOS</h3>`
        }
        pop_content.innerHTML += `<p>Coordinates: <span style="${coordsStyle}">${coordsFormat1} </span></p>`
        // Add displacement rate
        pop_content.innerHTML += `<p>Displacement rate: <span style="${coordsStyle}">9.8 mm/year</span></p>`
        pop_content.innerHTML += `<p>Coherence: <span style="${coordsStyle}">0.8</span></p>`
        pop_content.innerHTML += '<canvas id="time-series-chart"></canvas>'
        // Add some dummy dates and values for the chart
        const dates = ['2016-01-03', '2016-01-15', '2016-01-27', '2016-02-08', '2016-02-20', '2016-03-03', '2016-03-27', '2016-04-08', '2016-04-20', '2016-05-02', '2016-05-14', '2016-05-26', '2016-06-07', '2016-07-01', '2016-07-13', '2016-08-18', '2016-08-30', '2016-09-11', '2016-09-23', '2016-10-05', '2016-10-11', '2016-10-17', '2016-10-23', '2016-10-29', '2016-11-04', '2016-11-10', '2016-11-16', '2016-11-22', '2016-11-28', '2016-12-10', '2016-12-16', '2016-12-22', '2016-12-28', '2017-01-03', '2017-01-09', '2017-01-15', '2017-01-21', '2017-01-27', '2017-02-02', '2017-02-08', '2017-02-14', '2017-02-20', '2017-02-26', '2017-03-04', '2017-03-10', '2017-03-16', '2017-03-22', '2017-03-28', '2017-04-03', '2017-04-09', '2017-04-15', '2017-04-27', '2017-05-03', '2017-05-09', '2017-05-15', '2017-05-21', '2017-05-27', '2017-06-02', '2017-06-08', '2017-06-14', '2017-06-20', '2017-06-26', '2017-07-02', '2017-07-08', '2017-07-14', '2017-07-20', '2017-07-26', '2017-08-01', '2017-08-07', '2017-08-13', '2017-08-19', '2017-08-25', '2017-08-31', '2017-09-06', '2017-09-12', '2017-09-18', '2017-09-24', '2017-09-30', '2017-10-06', '2017-10-12', '2017-10-18', '2017-10-24', '2017-10-30', '2017-11-05', '2017-11-11', '2017-11-17', '2017-11-23', '2017-11-29', '2017-12-05', '2017-12-11', '2017-12-17', '2017-12-23', '2017-12-29', '2018-01-04', '2018-01-10', '2018-01-16', '2018-01-22', '2018-01-28', '2018-02-03', '2018-02-09', '2018-02-15', '2018-02-21', '2018-02-27', '2018-03-05', '2018-03-11', '2018-03-17', '2018-03-23', '2018-04-04', '2018-04-10', '2018-04-16', '2018-04-22', '2018-04-28', '2018-05-04', '2018-05-10', '2018-05-16', '2018-05-22', '2018-05-28', '2018-06-03', '2018-06-09', '2018-06-15', '2018-06-21', '2018-06-27', '2018-07-03', '2018-07-09', '2018-07-15', '2018-07-21', '2018-07-27', '2018-08-02', '2018-08-08', '2018-08-14', '2018-08-20', '2018-08-26', '2018-09-01', '2018-09-07', '2018-09-13', '2018-09-19', '2018-09-25', '2018-10-01', '2018-10-07', '2018-10-13', '2018-10-19', '2018-10-25', '2018-10-31', '2018-11-06', '2018-11-12', '2018-11-18', '2018-11-24', '2018-11-30', '2018-12-12', '2018-12-18', '2018-12-24', '2018-12-30']
        const values = [0.0022245, 0.0009192, 0.0009571, 0.0012998, 0.0012764, 0.0015602, 0.0022797, 0.0026023, 0.0021281, 0.0019646, 0.0020204, 0.0017966, 0.0013870, 0.0024734, 0.0023533, 0.0022592, 0.0017510, 0.0014114, 0.0008120, -0.0001403, -0.0001067, -0.0004498, -0.0010186, -0.0004864, -0.0011030, -0.0025000, -0.0029722, -0.0036276, -0.0036970, -0.0044428, -0.0045728, -0.0046698, -0.0047687, -0.0043650, -0.0039744, -0.0039200, -0.0032874, -0.0030186, -0.0025464, -0.0017334, -0.0005203, 0.0000193, -0.0007788, -0.0000452, 0.0000656, -0.0003569, -0.0008347, -0.0000300, -0.0008556, -0.0004503, -0.0009827, -0.0016481, -0.0022399, -0.0020032, -0.0016213, -0.0013668, -0.0012643, -0.0009000, -0.0005986, -0.0010051, 0.0002533, 0.0015111, 0.0025049, 0.0032520, 0.0031416, 0.0025473, 0.0026887, 0.0020492, 0.0015549, 0.0015165, 0.0014618, 0.0006520, 0.0002061, -0.0009062, -0.0011788, -0.0020578, -0.0019476, -0.0013783, -0.0006718, -0.0004449, -0.0002659, -0.0009853, -0.0013305, -0.0008281, -0.0007615, -0.0004846, -0.0010271, 0.0001650, 0.0000837, 0.0004875, -0.0001589, -0.0001378, 0.0002058, 0.0009254, 0.0010358, 0.0002678, -0.0000857, -0.0008855, -0.0004887, -0.0014553, -0.0016595, -0.0026629, -0.0022435, -0.0019927, -0.0023176, -0.0021236, -0.0020210, -0.0012096, -0.0006070, 0.0001285, -0.0002002, 0.0001073, 0.0000461, 0.0002397, -0.0005865, -0.0003372, -0.0006523, -0.0011498, -0.0012893, -0.0015859, -0.0030778, -0.0036762, -0.0039667, -0.0045255, -0.0043999, -0.0041619, -0.0028504, -0.0035210, -0.0032727, -0.0038546, -0.0035499, -0.0039836, -0.0026243, -0.0018159, -0.0010531, -0.0009224, -0.0015129, -0.0007690, -0.0007250, -0.0004365, -0.0007448, 0.0004081, 0.0003601, 0.0007218, 0.0010785, 0.0001459, -0.0008378, -0.0005955, 0.0001602, -0.0006331, -0.0019936, -0.0023644,]



        // Create a time series chart
        const formattedData = dates.reduce((acc, date, index) => {
          acc[date] = -values[index]
          return acc
        }, {})

        // Convert this into a chart.js time series chart
        // make some data with 'labels', 'datasets'
        const labels = Object.keys(formattedData)
        const data = {
          labels: labels,
          datasets: [
            {
              label: 'Displacement Time Series',
              data: Object.values(formattedData),
              fill: false,
              borderColor: 'rgb(75, 192, 192)',
              tension: 0.1
            }
          ]
        }
        // get the canvas
        const chartbox = document.getElementById('time-series-chart') as HTMLCanvasElement
        if (chartbox === null) {
          throw new Error('chartbox is null')
        }

        // y axis label
        const yaxis = document.createElement('div')
        yaxis.innerHTML = 'Displacement (m)'
        yaxis.style.position = 'absolute'
        yaxis.style.top = '10px'
        yaxis.style.left = '10px'
        // pop_content.appendChild(yaxis)
        // Make sure the yaxis labe;

        // Set the width of the popup as a proportion of the map width
        updatePopupWidth(map.getSize()[0]);

        // To control the size of the chart we need to set the width of the canvas / parent div
        console.log(chartbox)
        console.log(chartbox.style.width)
        console.log(baseWidth.value)
        // set the canvas width
        console.log("Setting chart width to: ", baseWidth.value)
        chartbox.width = baseWidth.value

        // Get the canvas
        new Chart(chartbox, {
          type: 'line',
          data: data,
          options: {
            responsive: true,
            scales: {
              y: {
                title: {                 // Add this section
                  display: true,      // Make sure the title is displayed
                  text: 'Displacement (m)', // Set the title text
                  color: 'black',     // Optional: Set the color of the title
                  font: {             // Optional: Customize font properties
                    size: 16,       // Font size
                    family: 'Arial' // Font family
                  }
                },
              }
            }
          }
        })

        // Y axis label
        console.log("Setting popup position to: ", coords)

        pop_overlay.setPosition(coords)
        // translate the pop_overlay by -100% of height
        const heightOfPopup = pop_container.clientHeight
        // shift slightly to the left to account for the popup arrow position,
        // and shift up by the height of the arrow
        pop_overlay.setOffset([-48, -heightOfPopup - 10])

        // add the onclick event to make the popup cover the screen
        // chartbox.onclick = overlayPopup
      })
      // Add the overlay to the map
      map.addOverlay(pop_overlay)


      // Add a vue watch for cohThreshold
      watch(cohThreshold, (newVal) => {
        console.log('Coh threshold changed:', newVal)

        try {
          // Clear the old vector source layer
          map.getLayers().forEach((layer) => {
            if (layer instanceof WebGLPointsLayer) {
              map.removeLayer(layer)
            }
          })
        } catch (error) {
          console.log('Error removing old vector source:', error)
        }

        try {

          const newGeoJson = new GeoJSON()
          const newFeatures = newGeoJson.readFeatures(featuresContainer.value, {
            // source projection is EPSG:4326
            dataProjection: 'EPSG:4326',
            featureProjection: map.getView().getProjection()
          })
          // Get the source of the layer
          const vectorSource = new VectorSource({
            features: newFeatures,
            format: newGeoJson,

          }) // vector source

          try {
            const webGLPointsLayer = new WebGLPointsLayer({
              source: vectorSource,
              // style: new Style({
              //     image: new CircleStyle({
              //         radius: 5,
              //         fill: new Fill({ color: '#ff0000' })
              //     })
              // })
              style: {
                'circle-radius': 3,
                'circle-fill-color': [
                  'interpolate',
                  ['linear'],
                  ['get', 'VEL'],
                  -0.01, '#ff0000',
                  -0.005, '#aaaa00',
                  0, '#00ff00',
                  0.005, '#00aaaa',
                  0.01, '#0000ff'
                ],
                // 'circle-fill-color': [
                //     'interpolate',
                //     ['linear'],
                //     ['get', 'COHERENCE'],
                //     0.0, '#000000',
                //     1.0, '#ffffff'
                // ],
                // 'circle-fill-color': '#ff0000',
                'circle-rotate-with-view': false,
                'circle-displacement': [0, 0],

              }
            }) // new WebGLPointsLayer

            try {
              map.addLayer(webGLPointsLayer)
            } catch (error) {
              console.log('Error adding new WebGLPointsLayer:', error)
            }

          } catch (error) {
            console.log('Error creating new WebGLPointsLayer:', error)
          }

        } catch (error) {
          console.log('Error creating new vector source:', error)
        }





      }) // watch


    }) // onMounted

    return {
      siteId,
      cohThreshold
    }
  }
})
</script>

<template>
  <div class="flex">
    <div class="w-1over3">
      <h1>{{ siteId }} Time Series Views</h1>
      <!-- Table for available point layers -->
      <table>
        <tr>
          <th>Time Series Layers</th>
        </tr>
        <tr>
          <td>
            <input type="radio" id="track30" name="pointLayer" value="track30">
            <label for="track30">Sentinel-1 Track 81 LOS</label>
          </td>
        </tr>
        <!-- <tr>
                    <td>
                        <input type="radio" id="track134" name="pointLayer" value="track134">
                        <label for="track134">Sentinel-1 Track 134 LOS</label>
                    </td>
                </tr>
                <tr>
                  <td>
                    <input type="radio" id="track134" name="pointLayer" value="track134">
                    <label for="track134">Sentinel-1 Vertical Component</label>
                  </td>
                </tr>
                <tr>
                  <td>
                    <input type="radio" id="track134" name="pointLayer" value="track134">
                    <label for="track134">Sentinel-1 East-West Component</label>
                  </td>
                </tr> -->
      </table>


      <h1>View Controls</h1>
      <!-- Table for view controls -->
      <table>
        <tr>
          <th>Control</th>
          <th>Value</th>
        </tr>
        <!-- Dropdown for colour ramp preset -->
        <tr>
          <td>Colour Ramp</td>
          <td>
            <select id="colour-ramp" name="colour-ramp">
              <option value="RGB">RGB</option>
            </select>
          </td>
        </tr>
        <tr>
          <td>Coherence Threshold</td>
          <td>
            <input type="range" id="coherence-threshold" name="coherence-threshold" min="0" max="1" step="0.01"
              value="0.7" v-model="cohThreshold">
            {{ cohThreshold }}
          </td>
        </tr>
        <tr>
          <td>Velocity Colour Limit</td>
          <td>
            <input type="range" id="velocity-ramp" name="velocity-ramp" min="0" max="1" step="0.01" value="0.01">
            0.01
          </td>
        </tr>
        <tr>
          <td>Date Range</td>
          <td>
            <input type="date" id="date-range" name="date-range">
            to
            <input type="date" id="date-range" name="date-range">
          </td>
        </tr>
      </table>

    </div>
    <div class="w-2over3">
      <MapComponent />
    </div>
  </div>
  <!-- container -->
  <div id="popup" class="ol-popup">
    <a href="#" id="popup-closer" class="ol-popup-closer"></a>
    <div id="popup-content"></div>
  </div>
</template>

<style scoped>
.flex {
  display: flex;
}

.w-1over3 {
  width: 33.33%;
}

.w-2over3 {
  width: 66.67%;
}

#false-color-composite-list {
  display: none;
}

#page-header {
  text-align: center;
  color: var(--color-text);
  font-size: 24px;
}

/* Add a global class that forces the grid layour for container */
.site-hub-container {
  display: grid;
  grid-template-columns: 1fr 3fr;
  /* Two columns, adjust the width as needed */
}

/* Controls on the left */
.controls {
  /* background-color: #f0f0f0;  */
  /* Background color for the left column */
  padding: 20px;
  /* Add padding for spacing */
}

.control-box {
  border: var(--color-text) 1px double;
  padding: 10px;
}

/* Map container on the right */
.map-container {
  /* You can adjust the size of the map container here */
  width: 100%;
  height: 400px;
  /* Adjust the height as needed */
  position: relative;
  /* Ensure relative positioning for children elements */
}

/* Style map buttons as needed */
.map-container button {
  margin-top: 10px;
  /* Add margin between buttons and the map */
}

/* Style the links in the control panel as buttons */
.vertical-controls a {
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 5px;
  border: 1px solid var(--color-border);
  border-radius: 5px;
  text-decoration: none;
  color: var(--color-text);
  background-color: var(--color-background);
}

.vertical-controls a {
  flex: 1;
  text-align: center;
}

/* Hover background */
.vertical-controls a:hover {
  background-color: var(--color-background-mute);
}

.horizontal-controls {
  display: flex;
  flex-direction: row;
  padding: 10px;
  justify-content: space-evenly;
}

.no-border {
  border: none;
}

.site-data-item {
  background-color: var(--color-background-mute);
  padding: 5px;
  margin: 5px;
  border: 1px solid var(--brand-color);
  border-radius: 5px;
  text-decoration: none;
  color: #000;
}

.site-data-item:hover {
  background-color: var(--color-background);
}

.ol-popup {
  position: absolute;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  padding: 15px;
  border-radius: 10px;
  border: 1px solid var(--color-border);
  color: black;
}

.ol-popup:after,
.ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}

.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}

.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
}

.ol-popup-closer:after {
  content: '✖';
}
</style>